import { CaretRightIcon, IdentificationBadgeIcon, UserIcon } from "@phosphor-icons/react";

import type { SafetyMeetingLiveAttendanceMeetingSnapshot } from "@miter/types/common";

import { MeetingHeader } from "safety/components/attendance/MeetingHeader";

const CHOICE_CLASS =
  "tw:flex tw:cursor-pointer tw:items-center tw:gap-3 tw:rounded-sm tw:border tw:border-stroke tw:bg-white tw:p-4 tw:text-left tw:active:bg-off-white";

type ChoiceButtonProps = {
  icon: React.ReactNode;
  tileClass: string;
  title: string;
  description: string;
  onClick: () => void;
};

const ChoiceButton = ({
  icon,
  tileClass,
  title,
  description,
  onClick,
}: ChoiceButtonProps): React.JSX.Element => (
  <button type="button" className={CHOICE_CLASS} onClick={onClick}>
    <div
      className={`tw:flex tw:size-11 tw:shrink-0 tw:items-center tw:justify-center tw:rounded-sm ${tileClass}`}
    >
      {icon}
    </div>
    <div className="tw:flex-1">
      <div className="tw:text-base tw:font-denim tw:text-midnight">{title}</div>
      <div className="tw:text-sm tw:text-midnight/60">{description}</div>
    </div>
    <CaretRightIcon size={18} className="tw:text-midnight/40" />
  </button>
);

type LandingScreenProps = {
  snapshot: SafetyMeetingLiveAttendanceMeetingSnapshot;
  signInTeamMember: () => void;
  signInVisitor: () => void;
};

export const LandingScreen = ({
  snapshot,
  signInTeamMember,
  signInVisitor,
}: LandingScreenProps): React.JSX.Element => (
  <>
    <MeetingHeader snapshot={snapshot} />
    <div className="tw:flex tw:w-full tw:flex-1 tw:flex-col tw:gap-3 tw:p-5">
      <div className="tw:font-denim tw:text-lg tw:text-midnight">Add yourself to this meeting</div>
      <ChoiceButton
        icon={<IdentificationBadgeIcon size={24} className="tw:text-white" />}
        tileClass="tw:bg-primary-purple"
        title="I work here"
        description="Use your 4-digit kiosk PIN"
        onClick={signInTeamMember}
      />
      <ChoiceButton
        icon={<UserIcon size={24} className="tw:text-midnight" />}
        tileClass="tw:border tw:border-stroke tw:bg-off-white"
        title="I’m a visitor"
        description="Subcontractor or site guest"
        onClick={signInVisitor}
      />
    </div>
  </>
);
